<template>
     <div v-if="type != 'new'" :class="[{ action : actionOn }, getDnaClass ]" class="card-item">
        <div class="top-label">
            <header>{{ card.element }}</header>
            <div v-if="card.dna" class="sub-text">{{ card.dna.split('_')[1] }}</div>
            <div v-else class="sub-text">gen-0</div>
        </div>
        <img :src="card.imgUrl" alt=""/>

        <span class="power-tag top-left">
            <span class="score">
                {{ card.strength }}
            </span>
            <span class="text">
                Strength
            </span>           
        </span>
        <span class="power-tag top-right">
            <span class="score">
                {{ card.speed }}
            </span>
            <span class="text">
                Speed
            </span>   
        </span>
        <span class="power-tag bottom-left">
            <span class="score">
                {{ card.defense }}
            </span>
            <span class="text">
                Defense
            </span>   
        </span>
        <span class="power-tag bottom-right">
            <span class="score">
                {{ card.stamina }}
            </span>
            <span class="text">
                Stamina
            </span>   
        </span>

        <span class="bottom-label">
            {{ card.name }}
            <div class="bottom-sub-label">Level: {{ card.level }}</div>
        </span>
    </div>  
    <div v-else class="card-item new">
        <i class="fas fa-question"></i>
    </div> 
</template>

<script>
import { mapGetters } from "vuex";
import { CHARACTERS, ELEMENTS } from "../util/constants/cards";

export default {
    name: "card",
    props: [ "card", "type", "actionOn" ],
    computed: {
        getDnaClass () {
            return this.card.dna ? this.card.dna.split('_')[1] : 'gen-0';
        }
    }
};
</script>

<style lang="less">
.card-item {
    border: 3px solid #fff;
    border-radius: 5px;
    display: inline-block;
    text-align: center;
    width: 100%;
    height: 400px;
    font-size: 52px;
    padding-top: 90px;
    color: #ccc;
    position: relative;
    background: #B9BAD7;

    -webkit-box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.75);

    &.gen-x {
        background: #B993D6;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to bottom, #8CA6DB, #B993D6);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to bottom, #8CA6DB, #B993D6); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }

    &.new {
        color: #fff;
        font-size: 56px;
    }

    .top-label {
        position: absolute;
        top: 15px; left: 0;
        color: #fff;
        width: 100%;
        padding: 0 80px;
        word-wrap: break-word;
        text-transform: capitalize;

        header {
            font-size: 18px;
        }

        .sub-text {
            font-size: 12px;
            font-weight: normal;
        }
    }

    .bottom-label {
        position: absolute;
        bottom: 12px; left: 0;
        font-size: 16px;
        color: #fff;  
        width: 100%;
        padding: 0 80px;
        word-wrap: break-word;
        text-transform: capitalize;

        .bottom-sub-label {
            font-size: 13px;
        }
    }

    img {
        height: 60%;
    }

    i {
        margin-top: 75px;
    }

    .power-tag {
        position: absolute;
        padding: 5px;
        font-size: 16px;
        color: #fff;
        border: 3px solid #fff;
        border-radius: 5px;
        width: 70px;

        &.top-left {
            top: 10px;
            left: 10px;
        }
        &.top-right {
            top: 10px;
            right: 10px;
        }
        &.bottom-left {
            bottom: 10px;
            left: 10px;
        }
        &.bottom-right {
            bottom: 10px;
            right: 10px;
        }

        .score {
            font-weight: bold;
            display: block;
        }

        .text {
            font-size: 11px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue